import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSent = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 11,
	height: 8,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#6B7A8A",
		fillRule: "nonzero",
		d: "M10.17 0 3.696 6.445.73 4.082 0 4.99l3.377 2.69.411.319 6.792-6.764.42-.409z"
	})
});
export default SvgSent;
